module.exports = __webpack_public_path__ + "img/03.3410288f.png";